import { DocType } from 'definitions/DocType';
import { RES_SRCH } from 'language/resi18n_all_search_page';

export const SearchDivisionTab = Object.freeze({
  ALL: 'ALL',
  DOWNLOAD: 'DOWNLOAD',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE',
  QNA: 'QNA',
  SAMPLE: 'SAMPLE',
  EDUCATION: 'EDUCATION',
  NEWS_EVENT: 'NEWS_EVENT',
});

export type TSearchDivisionTab = (typeof SearchDivisionTab)[keyof typeof SearchDivisionTab];

export interface ISearchDivisionTabConfig {
  key: TSearchDivisionTab;
  labelKey: RES_SRCH;
  //useFileSearch: boolean;
  //docType?: string;
}

export const SEARCH_DIVISION_TABS: ISearchDivisionTabConfig[] = [
  { key: SearchDivisionTab.ALL, labelKey: 'I18N_ALL_SEARCH_TAB_ALL' },
  { key: SearchDivisionTab.DOWNLOAD, labelKey: 'I18N_SEARCH_TAB_DOWNLOAD' },
  { key: SearchDivisionTab.KNOWLEDGE_BASE, labelKey: 'I18N_SEARCH_TAB_KNOWLEDGE_BASE' },
  { key: SearchDivisionTab.QNA, labelKey: 'I18N_TAB_QNA' },
  { key: SearchDivisionTab.SAMPLE, labelKey: 'I18N_SEARCH_TAB_SAMPLE_LIBRARY' },
  { key: SearchDivisionTab.EDUCATION, labelKey: 'I18N_SEARCH_TAB_EDUCATION' },
  { key: SearchDivisionTab.NEWS_EVENT, labelKey: 'I18N_SEARCH_TAB_NEWS_EVENT' },
];

export const DOWNLOAD_DOC_TYPES = [
  DocType.MANUAL,
  DocType.CATALOG,
  DocType.CERTIFICATION,
  DocType.CAD_DATA,
  DocType.DATASHEET,
  DocType.SOFTWARE,
  // DocType.EDUCATION_INTERNAL,
  // DocType.EDUCATION_NOTE,
  // DocType.EDUCATION_VIDEO,
  DocType.OS,
  DocType.MARKETING_MATERIAL,
];
// ["APPLICATION_NOTE", "TECHNICAL_GUIDE", "TECH_GENERAL", "TROUBLE_SHOOTING_KNW"]
export const KNOWLEDGE_BASE_DOC_TYPES = [
  DocType.APPLICATION_NOTE,
  DocType.TECHNICAL_GUIDE,
  DocType.TROUBLE_SHOOTING_KNW,
  DocType.TECH_GENERAL,
];

export const QNA_DOC_TYPES = [DocType.QNA_Q, DocType.QNA_A];

export const SAMPLE_DOC_TYPES = [DocType.SAMPLE, DocType.USER_SAMPLE];

export const EDUCATION_DOC_TYPES = [DocType.EDUCATION_VIDEO, DocType.EDUCATION_NOTE, DocType.EDUCATION_INTERNAL];

// 자유(TIP)는 통합검색 뉴스/이벤트 탭 노출 대상에서 제외 (ko-KR/en-US/en 공통)
export const NEWS_EVENT_DOC_TYPES = [DocType.DOC_EVT, DocType.DOC_NOTI /*, DocType.TIP */];

export const DIVISION_DOC_TYPES: Record<TSearchDivisionTab, readonly string[]> = {
  [SearchDivisionTab.ALL]: [], // 각 탭의 모든 문서를 각각 조회하여 표시할 것.
  [SearchDivisionTab.DOWNLOAD]: DOWNLOAD_DOC_TYPES,
  [SearchDivisionTab.KNOWLEDGE_BASE]: KNOWLEDGE_BASE_DOC_TYPES,
  [SearchDivisionTab.QNA]: QNA_DOC_TYPES,
  [SearchDivisionTab.SAMPLE]: SAMPLE_DOC_TYPES,
  [SearchDivisionTab.EDUCATION]: EDUCATION_DOC_TYPES,
  [SearchDivisionTab.NEWS_EVENT]: NEWS_EVENT_DOC_TYPES,
};

export const ALL_DOC_TYPES = [
  ...DOWNLOAD_DOC_TYPES,
  ...KNOWLEDGE_BASE_DOC_TYPES,
  ...QNA_DOC_TYPES,
  ...SAMPLE_DOC_TYPES,
  ...EDUCATION_DOC_TYPES,
  ...NEWS_EVENT_DOC_TYPES,
];
